import React, { useState, useEffect, act } from "react";
import "./Orders.css";
import "../Inventory/Inventory.css";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import TablePagination from "@mui/material/TablePagination";
import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

export const Orders = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [orderList, setOrderList] = useState({});
  const [onlineOrderList, setOnlineOrderList] = useState({});
  const [activeMenu, setactiveMenu] = useState("orderList");
  function handleSelectMenu(menu) {
    setactiveMenu(menu);
  }

  // Filters
  const [searchText, setSearchText] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [status, setStatus] = useState("");
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [filterToggler, setFilterToggler] = useState("");

  // order list table pagination
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_order_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_order_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [totalCount, setTotalCount] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0); // reset to first page
    sessionStorage.setItem("dis_order_rowsPerPage", +event.target.value);
    sessionStorage.setItem("dis_order_page", 0);
  };

  async function FetchOrdersList() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1, // atleast 1 page
          page_size: rowsPerPage,
          search: searchText,
          payment_type: paymentType,
          status: status,
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get("/distributor/orders/", config);
      if (response.data.status === "success" || response.status === 200) {
        setOrderList(response.data?.data);
        setTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch order list");
      console.log("Failed to fetch order list");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchOrdersList();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        FetchOrdersList();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paymentType, status, selectedLabel]);

  // online orders pagination
  const [onlinepage, setOnlinePage] = useState(() => {
    const savedPage = sessionStorage.getItem("dis_online_order_page");
    return savedPage ? Number(savedPage) : 0;
  });
  const [onlinerowsPerPage, setOnlineRowsPerPage] = useState(() => {
    const savedRows = sessionStorage.getItem("dis_online_order_rowsPerPage");
    return savedRows ? Number(savedRows) : 5;
  });
  const [onlinetotalCount, setOnlineTotalCount] = useState(0);

  const handleChangeOnlineRowsPerPage = (event) => {
    setOnlineRowsPerPage(+event.target.value);
    setOnlinePage(0); // reset to first page
    sessionStorage.setItem("dis_online_order_rowsPerPage", +event.target.value);
    sessionStorage.setItem("dis_online_order_page", 0);
  };

  async function FetchOnlineOrdersList() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: onlinepage + 1, // atleast 1 page
          page_size: onlinerowsPerPage,
          search: searchText,
          payment_type: paymentType,
          status: status,
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get(
        "/distributor/online-orders/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setOnlineOrderList(response.data?.data);
        setOnlineTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch online order list",
      );
      console.log("Failed to fetch online order list");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchOnlineOrdersList();
  }, [onlinepage, onlinerowsPerPage]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (onlinepage !== 0) {
        setOnlinePage(0);
      } else {
        FetchOnlineOrdersList();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchText, paymentType, status, selectedLabel]);

  // CLEAR FILTERS
  function handleClearFilters() {
    setSearchText("");
    setFilterToggler("");
    setPaymentType("");
    setStatus("");
    setSelectedLabel("");
  }

  // RESET Search

  function handleReset() {
    setSearchText("");
  }

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="ordersContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Orders</div>
              <div className="inventorySubtitle">
                Manage orders received from sub-distributors
              </div>
            </div>
            <div className="addButtonContainer">
              <div className="inventoryBtnReorder">
                <button onClick={() => navigate("/state-orders-create")}>
                  New Order
                </button>
              </div>
            </div>
          </div>
          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Order Id"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Filter by</div>
                <Dropdown className="nestedDropdown">
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {filterToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        setFilterToggler("");
                        setPaymentType("");
                        setStatus("");
                      }}
                    >
                      All
                    </Dropdown.Item>

                    {/* Payment Type with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Payment Type ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Debit");
                            setPaymentType("Debit");
                            setStatus("");
                          }}
                        >
                          Debit
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Credit");
                            setPaymentType("Credit");
                            setStatus("");
                          }}
                        >
                          Credit
                        </Dropdown.Item>
                      </div>
                    </div>

                    {/* status with submenu */}
                    <div className="submenu-container">
                      <Dropdown.Item className="has-submenu">
                        Status ▸
                      </Dropdown.Item>

                      <div className="submenu">
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Approved");
                            setStatus("Approved");
                            setPaymentType("");
                          }}
                        >
                          Approved
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            setFilterToggler("Pending");
                            setStatus("Pending");
                            setPaymentType("");
                          }}
                        >
                          Pending
                        </Dropdown.Item>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {/* {(filterToggler || selectedLabel) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of{" "}
                </span>{" "}
                : &nbsp; {filterToggler ? filterToggler : ""}
                {selectedLabel ? `, ${selectedLabel}` : ""}
              </div>
              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                {" "}
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )} */}

          {(filterToggler || selectedLabel || searchText) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Search:</strong> {searchText}{" "}
                  </>
                )}
                {paymentType && (
                  <>
                    {" "}
                    , <strong>Payment:</strong> {paymentType}{" "}
                  </>
                )}
                {status && (
                  <>
                    {" "}
                    , <strong>Status:</strong> {status}{" "}
                  </>
                )}
                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          {/* cards section  */}
          <div className="OrdersCardsGrid">
            <div className="inventoryCard">
              <div>Total Orders</div>
              <div>
                {activeMenu === "orderList"
                  ? orderList?.order_card?.total_orders
                  : onlineOrderList?.order_card?.total_orders}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Pending Approval</div>
              <div style={{ color: "var(--color-btn-background)" }}>
                {" "}
                {activeMenu === "orderList"
                  ? orderList?.order_card?.pending_approval
                  : onlineOrderList?.order_card?.pending_approval}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Dispatched</div>
              <div>
                {activeMenu === "orderList"
                  ? orderList?.order_card?.dispatched
                  : onlineOrderList?.order_card?.dispatched}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Delivered</div>
              <div>
                {activeMenu === "orderList"
                  ? orderList?.order_card?.delivered
                  : onlineOrderList?.order_card?.delivered}
              </div>
            </div>
          </div>
          {/* table  */}
          {/* <div className="titleOrderList">Orders List</div> */}
          {/* table menu  */}
          <div className="inventoryFilterContainer">
            <div className="inventoryMenu">
              <div
                onClick={() => handleSelectMenu("orderList")}
                className={`menuTitle ${
                  activeMenu === "orderList" ? "active" : ""
                }`}
              >
                Orders List
              </div>
              <div
                onClick={() => handleSelectMenu("onlineOrderList")}
                className={`menuTitle ${activeMenu === "onlineOrderList" ? "active" : ""}`}
              >
                Online Orders List
              </div>
            </div>
            <div className="inventoryFilters">{""}</div>
          </div>

          <div className="dashboardTableContainer">
            {activeMenu === "orderList" && (
              <>
                <TableContainer component={Paper}>
                  <Table
                    // sx={{ minWidth: 650 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead className="dashboadTableHeader">
                      <TableRow>
                        <TableCell>Order ID</TableCell>
                        <TableCell align="left">Order Date</TableCell>
                        <TableCell align="left">Sub-Distributor</TableCell>
                        <TableCell align="left">No. of Products</TableCell>
                        <TableCell align="left">Total Amount (₹)</TableCell>
                        <TableCell align="left">Payment type</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {orderList?.results?.length > 0 ? (
                        orderList.results.map((row) => (
                          <TableRow
                            key={row.order_id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            className="dashboardTableBody"
                          >
                            <TableCell component="th" scope="row">
                              {row.order_id ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.order_date ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.sub_distributor ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.no_of_products ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.total_amount ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.payment_type ?? "---"}
                            </TableCell>

                            <TableCell
                              align="left"
                              style={{
                                color: (() => {
                                  switch (row.status) {
                                    case "Pending":
                                    case "PENDING":
                                      return "#EF4444";
                                    case "Approved":
                                    case "APPROVED":
                                      return "#45614C";
                                    case "Dispatched":
                                    case "DISPATCHED":
                                      return "#F59E0B";
                                    case "Delivered":
                                    case "DELIVERED":
                                      return "#10B981";
                                    default:
                                      return "var(--color-font-secondary)";
                                  }
                                })(),
                              }}
                            >
                              {row.status ?? "---"}
                            </TableCell>

                            <TableCell align="left">
                              {row.status === "Pending" ||
                              row.status === "PENDING" ? (
                                <button
                                  className="btnTableManage"
                                  onClick={() =>
                                    navigate("/state-orders-manage", {
                                      state: { Id: row.order_id },
                                    })
                                  }
                                >
                                  Manage
                                </button>
                              ) : (
                                <button
                                  className="btnTableView"
                                  onClick={() =>
                                    navigate("/state-invoice-view", {
                                      state: { Id: row.invoice_id },
                                    })
                                  }
                                >
                                  View
                                </button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={8}
                            align="center"
                            style={{ padding: "20px" }}
                          >
                            No orders available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={totalCount}
                  page={page}
                  onPageChange={(event, newPage) => {
                    setPage(newPage);
                    sessionStorage.setItem("dis_order_page", newPage);
                  }}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </>
            )}
            {activeMenu === "onlineOrderList" && (
              <>
                <TableContainer component={Paper}>
                  <Table
                    // sx={{ minWidth: 650 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead className="dashboadTableHeader">
                      <TableRow>
                        <TableCell>Order ID</TableCell>
                        <TableCell align="left">Order Date</TableCell>
                        <TableCell align="left">Agent Name</TableCell>
                        <TableCell align="left">Qty</TableCell>
                        <TableCell align="left">Total Amount (₹)</TableCell>
                        <TableCell align="left">Payment type</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {onlineOrderList?.results?.length > 0 ? (
                        onlineOrderList.results.map((row) => (
                          <TableRow
                            key={row.order_id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            className="dashboardTableBody"
                          >
                            <TableCell component="th" scope="row">
                              {row.order_id ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.order_date ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.agent_name ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.qty ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.total_amount ?? "---"}
                            </TableCell>
                            <TableCell align="left">
                              {row.payment_type ?? "---"}
                            </TableCell>

                            <TableCell
                              align="left"
                              style={{
                                color: (() => {
                                  switch (row.status) {
                                    case "Pending":
                                    case "PENDING":
                                      return "#EF4444";
                                    case "Approved":
                                    case "APPROVED":
                                      return "#45614C";
                                    case "Dispatched":
                                    case "DISPATCHED":
                                      return "#F59E0B";
                                    case "Delivered":
                                    case "DELIVERED":
                                      return "#10B981";
                                    default:
                                      return "var(--color-font-secondary)";
                                  }
                                })(),
                              }}
                            >
                              {row.status ?? "---"}
                            </TableCell>

                            <TableCell align="left">
                              {row.status === "Pending" ||
                              row.status === "PENDING" ? (
                                <button
                                  className="btnTableManage"
                                  onClick={() =>
                                    navigate("/state-orders-manage", {
                                      state: { Id: row.order_id },
                                    })
                                  }
                                >
                                  Manage
                                </button>
                              ) : (
                                <button
                                  className="btnTableView"
                                  onClick={() =>
                                    navigate("/state-invoice-view", {
                                      state: { Id: row.invoice_id },
                                    })
                                  }
                                >
                                  View
                                </button>
                              )}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={8}
                            align="center"
                            style={{ padding: "20px" }}
                          >
                            No orders available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={onlinetotalCount}
                  page={onlinepage}
                  onPageChange={(event, newPage) => {
                    setOnlinePage(newPage);
                    sessionStorage.setItem("dis_online_order_page", newPage);
                  }}
                  rowsPerPage={onlinerowsPerPage}
                  rowsPerPageOptions={[5, 10, 20, 50]} //dropdown
                  onRowsPerPageChange={handleChangeOnlineRowsPerPage}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
